import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ModalVideo from "react-modal-video";
import { getCMSGeneral, getCMSAssets } from "../../../utils/cms.utils";

const About = () => {
    const [openVideo, setOpenVideo] = useState(false);
    const [general, setGeneral] = useState(null);
    const [assets, setAssets] = useState(null);

    useEffect(() => {
        setGeneral(getCMSGeneral());
        setAssets(getCMSAssets());
    }, []);

    if (!general || !assets) return null;

    return (
        <>
            <div className="about__one section-padding pt-60 pb-60">
                <div className="container">

                    {/* ===== TITLE ===== */}
                    <div className="about__one-left-title text-center">
                        <span
                            className="subtitle wow fadeInLeft"
                            data-wow-delay=".4s"
                        >
                            About Our Company
                        </span>
                        <h3
                            className="wow fadeInRight"
                            data-wow-delay=".6s"
                        >
                            {general.companyName.toLocaleUpperCase()} ({general.companyShortname})
                        </h3>
                    </div>

                    <div className="about__divider mx-auto"></div>

                    <div className="row al-end">
                        {/* ===== IMAGE ===== */}
                        <div className="col-lg-5 lg-mb">
                            <div className="about__one-right t-right">
                                <img
                                    className="wow img_right_animation lg_img_full about__one-image-img"
                                    src={assets.about_us_overview}
                                    alt={general.companyName}
                                />
                            </div>
                        </div>

                        {/* ===== CONTENT ===== */}
                        <div className="col-lg-7 lg-mb-25">
                            <div className="about__one-left h-100">
                                <div className="row al-center mt-45">
                                    <div className="col-md-8 pl-50 xl-pl-10">
                                        <div className="about__one-left-list">

                                            {/* ===== VISION ===== */}
                                            <div
                                                className="about__one-left-list-item wow fadeInUp"
                                                data-wow-delay=".3s"
                                            >
                                                <i className="flaticon-creative-thinking"></i>
                                                <div className="about__one-left-list-item-content">
                                                    <h4>Vision</h4>
                                                    <div
                                                        className="about__text-main"
                                                        dangerouslySetInnerHTML={{
                                                            __html: general.visionEn,
                                                        }}
                                                    />
                                                    <div
                                                        className="about__text-sub"
                                                        dangerouslySetInnerHTML={{
                                                            __html: general.visionId,
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            {/* ===== MISSION ===== */}
                                            <div
                                                className="about__one-left-list-item wow fadeInUp"
                                                data-wow-delay=".5s"
                                            >
                                                <i className="flaticon-targeting"></i>
                                                <div className="about__one-left-list-item-content">
                                                    <h4>Mission</h4>
                                                    <div
                                                        className="about__text-main"
                                                        dangerouslySetInnerHTML={{
                                                            __html: general.missionEn,
                                                        }}
                                                    />
                                                    <div
                                                        className="about__text-sub"
                                                        dangerouslySetInnerHTML={{
                                                            __html: general.missionId,
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                        </div>

                                        {/* ===== CTA ===== */}
                                        <div
                                            className="wow fadeInDown text-center"
                                            data-wow-delay="1.2s"
                                        >
                                            <Link className="build_button mt-40" to="/about-us">
                                                Discover more
                                                <i className="flaticon-right-up"></i>
                                            </Link>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* ===== VIDEO MODAL (optional) ===== */}
            <ModalVideo
                className="video-modal"
                channel="youtube"
                autoplay
                isOpen={openVideo}
                videoId="SZEflIVnhH8"
                onClose={() => setOpenVideo(false)}
            />
        </>
    );
};

export default About;
